import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "text-caption text-grey-9" }
const _hoisted_2 = {
  key: 0,
  class: "q-pb-sm"
}
const _hoisted_3 = {
  class: "row items-start q-gutter-sm q-px-sm q-pb-sm",
  "data-testid": "view-passages-filter"
}
const _hoisted_4 = { class: "row no-wrap" }
const _hoisted_5 = { class: "row no-wrap" }
const _hoisted_6 = {
  key: 1,
  class: "q-px-sm q-pb-sm text-negative text-caption",
  "data-testid": "view-passages-filter-error"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_toolbar_title = _resolveComponent("q-toolbar-title")!
  const _component_q_space = _resolveComponent("q-space")!
  const _component_q_tooltip = _resolveComponent("q-tooltip")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_toolbar = _resolveComponent("q-toolbar")!
  const _component_q_badge = _resolveComponent("q-badge")!
  const _component_q_select = _resolveComponent("q-select")!
  const _component_q_date = _resolveComponent("q-date")!
  const _component_q_time = _resolveComponent("q-time")!
  const _component_q_popup_proxy = _resolveComponent("q-popup-proxy")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_input = _resolveComponent("q-input")!
  const _component_PassagesTable = _resolveComponent("PassagesTable")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_dialog = _resolveComponent("q-dialog")!
  const _directive_close_popup = _resolveDirective("close-popup")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_q_dialog, {
      modelValue: _ctx.passagesDialog,
      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.passagesDialog) = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_q_card, { style: {"width":"700px","max-width":"90vw"} }, {
          default: _withCtx(() => [
            _createVNode(_component_q_toolbar, null, {
              default: _withCtx(() => [
                _createVNode(_component_q_toolbar_title, { class: "text-blue-brand text-bold" }, {
                  default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                    _createTextVNode("Passages", -1)
                  ]))]),
                  _: 1
                }),
                _cache[12] || (_cache[12] = _createElementVNode("span", { class: "text-caption text-grey-7 q-mr-xs" }, "Marker Name:", -1)),
                _createElementVNode("span", _hoisted_1, _toDisplayString(_ctx.selectedMarkerName), 1),
                _createVNode(_component_q_space),
                (_ctx.sortedMarkers.length > 1)
                  ? (_openBlock(), _createBlock(_component_q_btn, {
                      key: 0,
                      flat: "",
                      round: "",
                      dense: "",
                      icon: "chevron_left",
                      color: "blue-brand",
                      disable: _ctx.loading,
                      onClick: _withModifiers(_ctx.onPrevMarker, ["stop"])
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_q_tooltip, null, {
                          default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                            _createTextVNode("Previous marker", -1)
                          ]))]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["disable", "onClick"]))
                  : _createCommentVNode("", true),
                (_ctx.sortedMarkers.length > 1)
                  ? (_openBlock(), _createBlock(_component_q_btn, {
                      key: 1,
                      flat: "",
                      round: "",
                      dense: "",
                      icon: "chevron_right",
                      color: "blue-brand",
                      disable: _ctx.loading,
                      onClick: _withModifiers(_ctx.onNextMarker, ["stop"])
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_q_tooltip, null, {
                          default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                            _createTextVNode("Next marker", -1)
                          ]))]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["disable", "onClick"]))
                  : _createCommentVNode("", true),
                _createVNode(_component_q_btn, {
                  flat: "",
                  round: "",
                  dense: "",
                  icon: "refresh",
                  loading: _ctx.loading,
                  onClick: _ctx.fetchPassages
                }, null, 8, ["loading", "onClick"]),
                _createVNode(_component_q_btn, {
                  flat: "",
                  round: "",
                  dense: "",
                  icon: "filter_alt",
                  color: _ctx.filterGreenMl ? 'green' : 'grey-6',
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.filterGreenMl = !_ctx.filterGreenMl))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_q_tooltip, null, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.filterGreenMl
                ? 'Showing green ML results only'
                : 'Filter to green ML results'), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["color"]),
                _withDirectives(_createVNode(_component_q_btn, {
                  flat: "",
                  round: "",
                  dense: "",
                  icon: "close",
                  onClick: _ctx.closeViewPsgs
                }, null, 8, ["onClick"]), [
                  [_directive_close_popup]
                ])
              ]),
              _: 1
            }),
            (_ctx.errorMsg)
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                  _createVNode(_component_q_badge, {
                    class: "q-ml-sm",
                    color: "red"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.errorMsg), 1)
                    ]),
                    _: 1
                  })
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_3, [
              (_ctx.markerFilterOptions.length > 0)
                ? (_openBlock(), _createBlock(_component_q_select, {
                    key: 0,
                    "model-value": _ctx.activePipelineSectionMarkerId,
                    dense: "",
                    filled: "",
                    "emit-value": "",
                    "map-options": "",
                    options: _ctx.markerFilterOptions,
                    disable: _ctx.loading,
                    label: "Marker",
                    style: {"min-width":"160px"},
                    "data-testid": "view-passages-marker-filter",
                    "onUpdate:modelValue": _ctx.onMarkerFilterSelected
                  }, null, 8, ["model-value", "options", "disable", "onUpdate:modelValue"]))
                : _createCommentVNode("", true),
              _createVNode(_component_q_input, {
                modelValue: _ctx.filterFrom,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.filterFrom) = $event)),
                dense: "",
                filled: "",
                mask: "####-##-## ##:##",
                label: "From (UTC)",
                hint: "YYYY-MM-DD HH:mm",
                style: {"width":"190px"},
                "data-testid": "view-passages-from"
              }, {
                append: _withCtx(() => [
                  _createVNode(_component_q_icon, {
                    name: "event",
                    class: "cursor-pointer"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_popup_proxy, {
                        "transition-show": "scale",
                        "transition-hide": "scale"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_4, [
                            _createVNode(_component_q_date, {
                              modelValue: _ctx.filterFrom,
                              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.filterFrom) = $event)),
                              mask: "YYYY-MM-DD HH:mm"
                            }, null, 8, ["modelValue"]),
                            _createVNode(_component_q_time, {
                              modelValue: _ctx.filterFrom,
                              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.filterFrom) = $event)),
                              mask: "YYYY-MM-DD HH:mm",
                              format24h: ""
                            }, null, 8, ["modelValue"])
                          ])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["modelValue"]),
              _createVNode(_component_q_input, {
                modelValue: _ctx.filterTo,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.filterTo) = $event)),
                dense: "",
                filled: "",
                mask: "####-##-## ##:##",
                label: "To (UTC)",
                hint: "YYYY-MM-DD HH:mm",
                style: {"width":"190px"},
                "data-testid": "view-passages-to"
              }, {
                append: _withCtx(() => [
                  _createVNode(_component_q_icon, {
                    name: "event",
                    class: "cursor-pointer"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_popup_proxy, {
                        "transition-show": "scale",
                        "transition-hide": "scale"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_5, [
                            _createVNode(_component_q_date, {
                              modelValue: _ctx.filterTo,
                              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.filterTo) = $event)),
                              mask: "YYYY-MM-DD HH:mm"
                            }, null, 8, ["modelValue"]),
                            _createVNode(_component_q_time, {
                              modelValue: _ctx.filterTo,
                              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.filterTo) = $event)),
                              mask: "YYYY-MM-DD HH:mm",
                              format24h: ""
                            }, null, 8, ["modelValue"])
                          ])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["modelValue"]),
              _createVNode(_component_q_btn, {
                flat: "",
                dense: "",
                "no-caps": "",
                label: "Clear",
                color: "blue-brand",
                disable: !_ctx.filterFrom && !_ctx.filterTo,
                "data-testid": "view-passages-clear",
                onClick: _ctx.clearTimeFilter
              }, null, 8, ["disable", "onClick"])
            ]),
            (_ctx.timeFilterRange.error)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(_ctx.timeFilterRange.error), 1))
              : _createCommentVNode("", true),
            _createVNode(_component_PassagesTable, {
              ref: "passagesTable",
              pagination: _ctx.passagePagination,
              "onUpdate:pagination": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.passagePagination) = $event)),
              rows: _ctx.displayedPassages,
              loading: _ctx.loading,
              "no-data-label": _ctx.noDataLabel,
              "dialog-source": "marker_passages",
              "ml-opens-chart": "",
              "pig-run-id": _ctx.activePigRunId,
              "pipeline-section-marker-id": _ctx.activePipelineSectionMarkerId,
              "marker-name": _ctx.selectedMarkerName,
              active: _ctx.passagesDialog && _ctx.chartStepsHere
            }, null, 8, ["pagination", "rows", "loading", "no-data-label", "pig-run-id", "pipeline-section-marker-id", "marker-name", "active"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}